import { useEffect, useRef } from 'react';
import { Scene } from '@babylonjs/core';
import "../../layout/game/HUDComponement";

type Props = {
    scene: Scene;
    visibility: boolean;
};

function FPS({ scene, visibility }: Props) {
    const overlayRef = useRef<HTMLDivElement | null>(null);

    // ── Création de l'overlay DOM ─────────────────────────────────────────────
    useEffect(() => {
        if (!visibility) {
            overlayRef.current?.remove();
            overlayRef.current = null;
            return;
        }

        const overlay = document.createElement('div');
        overlay.className = 'cardige';
        overlay.innerHTML = 'fps';
        overlay.style.cssText = `
      position: absolute;
      top: 16px;
      right: 16px;
      pointer-events: none;
      z-index: 10;
    `;

        const canvas = scene.getEngine().getRenderingCanvas();
        const container = canvas?.parentElement ?? document.body;
        container.style.position = 'relative';
        container.appendChild(overlay);
        overlayRef.current = overlay;

        return () => {
            overlay.remove();
            overlayRef.current = null;
        };
    }, [scene, visibility]);

    // ── Boucle FPS ────────────────────────────────────────────────────────────
    useEffect(() => {
        if (!scene || !visibility) return;

        const updateFps = () => {
            if (overlayRef.current) {
                // On met à jour directement le div overlay, plus besoin d'un ref séparé
                overlayRef.current.innerHTML =
                    scene.getEngine().getFps().toFixed() + ' fps';
            }
        };

        scene.registerBeforeRender(updateFps);

        return () => {
            scene.unregisterBeforeRender(updateFps);
        };
    }, [scene, visibility]);

    // Aucun élément DOM React — tout passe par document.createElement
    return null;
}

export default FPS;